import Vue from "vue";
import Vuex from "vuex";
import VueJwtDecode from 'vue-jwt-decode'
import router from "./router/";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    jwt: localStorage.getItem('t'),
    refresh: localStorage.getItem('r'),
    autores: [],
    categorias: [],
    editoriales: [],
    usuarios: [],
    bitacora: [],
    libro: [],
    endpoints: {
      //LOCAL
      /*obtainJWT: 'http://localhost:8000/api/token/',
      refreshJWT: 'http://localhost:8000/api/token/refresh/',
      baseUrl: 'http://localhost:8000/api/'*/
      //SERVER 
      obtainJWT: '/api/token/',
      refreshJWT: '/api/token/refresh/',
      baseUrl: '/api/'
    },
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 10,
      totalItems: 0,
      rowsPerPageItems: [10],
      nextPage: "",
      previousPage: ""
    },
    paginationCategoria: {
      descending: true,
      page: 1,
      rowsPerPage: 10,
      totalItems: 0,
      rowsPerPageItems: [10],
      nextPage: "",
      previousPage: ""
    },
    paginationEditorial: {
      descending: true,
      page: 1,
      rowsPerPage: 10,
      totalItems: 0,
      rowsPerPageItems: [10],
      nextPage: "",
      previousPage: ""
    },
    paginationUsuario: {
      descending: true,
      page: 1,
      rowsPerPage: 10,
      totalItems: 0,
      rowsPerPageItems: [10],
      nextPage: "",
      previousPage: ""
    },
    paginationBitacora: {
      descending: true,
      page: 1,
      rowsPerPage: 10,
      totalItems: 0,
      rowsPerPageItems: [10],
      nextPage: "",
      previousPage: ""
    },
    paginationLibro: {
      descending: true,
      page: 1,
      rowsPerPage: 10,
      totalItems: 0,
      rowsPerPageItems: [10],
      nextPage: "",
      previousPage: ""
    },
  },
  getters: {
    token: state => state.jwt,
    refresh: state => state.refresh,
    autores: state => state.autores,
    categorias: state => state.categorias,
    editoriales: state => state.editoriales,
    usuarios: state => state.usuarios,
    bitacora: state => state.bitacora,
    libro: state => state.libro
  },
  mutations: {
    updateToken(state, newToken) {
      state.jwt = newToken;
    },
    removeToken(state) {
      localStorage.removeItem('t');
      localStorage.removeItem('r');
      localStorage.removeItem('u');
      state.jwt = null;
      state.refresh = null;
    },
    updateAutoresList(state, newList) {
      state.autores = newList;
    },
    setPagination(state, { total, next, previous }) {
      state.pagination.totalItems = total;
      state.pagination.nextPage = next;
      state.pagination.previousPage = previous;
    },
    /// MUTACIONES DE CATEGORIA -------------------------------->

    updateCategoriasList(state, newList) {
      state.categorias = newList;
    },
    setPaginationCategoria(state, { total, next, previous }) {
      state.paginationCategoria.totalItems = total;
      state.paginationCategoria.nextPage = next;
      state.paginationCategoria.previousPage = previous;
    },
    /// FIN MUTACIONES CATEGORIA ------------------------------->
    /// MUTACIONES DE EDITORIAL -------------------------------->

    updateEditorialesList(state, newList) {
      state.editoriales = newList;
    },
    setPaginationEditorial(state, { total, next, previous }) {
      state.paginationEditorial.totalItems = total;
      state.paginationEditorial.nextPage = next;
      state.paginationEditorial.previousPage = previous;
    },
    /// FIN MUTACIONES EDITORIAL ------------------------------->

    /// MUTACIONES DE USUARIOS -------------------------------->

    updateUsuarioList(state, newList) {
      state.usuarios = newList;
    },
    setPaginationUsuario(state, { total, next, previous }) {
      state.paginationUsuario.totalItems = total;
      state.paginationUsuario.nextPage = next;
      state.paginationUsuario.previousPage = previous;
    },
    /// FIN MUTACIONES USAURIOS ------------------------------->
    /// MUTACIONES DE BITACORA -------------------------------->

    updateBitacoraList(state, newList) {
      state.bitacora = newList;
    },
    setPaginationBitacora(state, { total, next, previous }) {
      state.paginationBitacora.totalItems = total;
      state.paginationBitacora.nextPage = next;
      state.paginationBitacora.previousPage = previous;
    },
    /// FIN MUTACIONES BITACORA ------------------------------->

    /// MUTACIONES DE LIBRO -------------------------------->

    updateLibroList(state, newList) {
      state.libro = newList;
    },
    setPaginationLibro(state, { total, next, previous }) {
      state.paginationLibro.totalItems = total;
      state.paginationLibro.nextPage = next;
      state.paginationLibro.previousPage = previous;
    },
    /// FIN MUTACIONES LIBRO ------------------------------->

  },
  actions: {
    obtainToken(state, data) {
      const payload = {
        username: data.username,
        password: data.password
      }
      Vue.axios.post(this.state.endpoints.obtainJWT, payload)
        .then((response) => {
          let token = response.data.token;
          localStorage.setItem('t', token);
          let Tokendata = VueJwtDecode.decode(token);
          localStorage.setItem('u', Tokendata.username);
          this.commit('updateToken', token);
        })
        .catch((error) => {
          this.commit('removeToken');
        })
    },
    refreshToken() {
      const payload = {
        token: this.state.refresh
      }
      Vue.axios.post(this.state.endpoints.refreshJWT, payload)
        .then((response) => {
          let token = response.data.token;
          this.commit('updateToken', token)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getAutores() {
      Vue.axios.get(this.state.endpoints.baseUrl + "autor/")
        .then(response => {
          let results = response.data.results;
          let total = response.data.count;
          let next = response.data.next;
          let previous = response.data.previous;
          this.commit('updateAutoresList', results);
          this.commit('setPagination', { total, next, previous });
        })
        .catch(error => {
          if (error.request.status === 401) {
            this.commit('removeToken');
            router.push("/login");
          }
        });
    },
    searchAutores(state, query) {
      Vue.axios.get(this.state.endpoints.baseUrl + "autor/", {
        params: {
          search: query
        }
      })
        .then(response => {
          let results = response.data.results;
          this.commit('updateAutoresList', results);
        })
        .catch(error => {
          if (error.request.status === 401) {
            this.commit('removeToken');
            router.push("/login");
          }
        });
    },
    updateAutor(state, autor) {
      Vue.axios.put(this.state.endpoints.baseUrl + "autor/" + autor.id + "/", autor)
        .then(response => {
          return response;
        })
        .catch(error => {
          if (error.request.status === 401) {
            this.commit('removeToken');
            router.push("/login");
          }
        });
    },
    createAutor(state, autor) {
      Vue.axios.post(this.state.endpoints.baseUrl + "autor/", autor)
        .then(response => {
          return response;
        })
        .catch(error => {
          if (error.request.status === 401) {
            this.commit('removeToken');
            router.push("/login");
          }
        });
    },
    deleteAutor(state, autor) {
      autor.activo = false;
      Vue.axios.put(this.state.endpoints.baseUrl + "autor/" + autor.id + "/", autor)
        .then(response => {
          return response;
        })
        .catch(error => {
          if (error.request.status === 401) {
            this.commit('removeToken');
            router.push("/login");
          }
        });
    },
    changePage(state, url) {
      Vue.axios.get(url)
        .then(response => {
          let results = response.data.results;
          let total = response.data.count;
          let next = response.data.next;
          let previous = response.data.previous;
          this.commit('updateAutoresList', results);
          this.commit('setPagination', { total, next, previous });
        })
        .catch(error => {
          if (error.request.status === 401) {
            this.commit('removeToken');
            router.push("/login");
          }
        });
    },

    // METODOS CATEGORIAS ---------------------------------------------------->

    getCategorias() {
      Vue.axios.get(this.state.endpoints.baseUrl + "categoria/")
        .then(response => {
          let results = response.data.results;
          let total = response.data.count;
          let next = response.data.next;
          let previous = response.data.previous;
          this.commit('updateCategoriasList', results);
          this.commit('setPaginationCategoria', { total, next, previous });
        })
        .catch(error => {
          if (error.request.status === 401) {
            this.commit('removeToken');
            router.push("/login");
          }
        });
    },
    searchCategoria(state, query) {
      Vue.axios.get(this.state.endpoints.baseUrl + "categoria/", {
        params: {
          search: query
        }
      })
        .then(response => {
          let results = response.data.results;
          this.commit('updateCategoriasList', results);
        })
        .catch(error => {
          if (error.request.status === 401) {
            this.commit('removeToken');
            router.push("/login");
          }
        });
    },
    updateCategoria(state, categoria) {
      Vue.axios.put(this.state.endpoints.baseUrl + "categoria/" + categoria.id + "/", categoria)
        .then(response => {
          return response;
        })
        .catch(error => {
          if (error.request.status === 401) {
            this.commit('removeToken');
            router.push("/login");
          }
        });
    },
    createCategoria(state, categoria) {
      Vue.axios.post(this.state.endpoints.baseUrl + "categoria/", categoria)
        .then(response => {
          return response;
        })
        .catch(error => {
          if (error.request.status === 401) {
            this.commit('removeToken');
            router.push("/login");
          }
        });
    },
    deleteCategoria(state, categoria) {
      categoria.activo = false;
      Vue.axios.put(this.state.endpoints.baseUrl + "categoria/" + categoria.id + "/", categoria)
        .then(response => {
          return response;
        })
        .catch(error => {
          if (error.request.status === 401) {
            this.commit('removeToken');
            router.push("/login");
          }
        });
    },


    // FIN METODOS DE CATEGORIAS ----------------------------------------------->


    //METODOS EDITORIALES ---------------------------------------------------->

    getEditoriales() {
      Vue.axios.get(this.state.endpoints.baseUrl + "editorial/")
        .then(response => {
          let results = response.data.results;
          let total = response.data.count;
          let next = response.data.next;
          let previous = response.data.previous;
          this.commit('updateEditorialesList', results);
          this.commit('setPaginationEditorial', { total, next, previous });
        })
        .catch(error => {
          if (error.request.status === 401) {
            this.commit('removeToken');
            router.push("/login");
          }
        });
    },
    searchEditorial(state, query) {
      Vue.axios.get(this.state.endpoints.baseUrl + "editorial/", {
        params: {
          search: query
        }
      })
        .then(response => {
          let results = response.data.results;
          this.commit('updateEditorialesList', results);
        })
        .catch(error => {
          if (error.request.status === 401) {
            this.commit('removeToken');
            router.push("/login");
          }
        });
    },
    updateEditorial(state, editorial) {
      Vue.axios.put(this.state.endpoints.baseUrl + "editorial/" + editorial.id + "/", editorial)
        .then(response => {
          return response;
        })
        .catch(error => {
          if (error.request.status === 401) {
            this.commit('removeToken');
            router.push("/login");
          }
        });
    },
    createEditorial(state, editorial) {
      Vue.axios.post(this.state.endpoints.baseUrl + "editorial/", editorial)
        .then(response => {
          return response;
        })
        .catch(error => {
          if (error.request.status === 401) {
            this.commit('removeToken');
            router.push("/login");
          }
        });
    },
    deleteEditorial(state, editorial) {
      editorial.activo = false;
      Vue.axios.put(this.state.endpoints.baseUrl + "editorial/" + editorial.id + "/", editorial)
        .then(response => {
          return response;
        })
        .catch(error => {
          if (error.request.status === 401) {
            this.commit('removeToken');
            router.push("/login");
          }
        });
    },


    // FIN METODOS DE EDITORIALES ----------------------------------------------->


    //METODOS USUARIOS ---------------------------------------------------->

    getUsuarios() {
      Vue.axios.get(this.state.endpoints.baseUrl + "usuario/")
        .then(response => {
          let results = response.data.results;
          let total = response.data.count;
          let next = response.data.next;
          let previous = response.data.previous;
          this.commit('updateUsuarioList', results);
          this.commit('setPaginationUsuario', { total, next, previous });
        })
        .catch(error => {
          if (error.request.status === 401) {
            this.commit('removeToken');
            router.push("/login");
          }
        });
    },
    searchUsuarios(state, query) {
      Vue.axios.get(this.state.endpoints.baseUrl + "usuario/", {
        params: {
          search: query
        }
      })
        .then(response => {
          let results = response.data.results;
          this.commit('updateUsuarioList', results);
        })
        .catch(error => {
          if (error.request.status === 401) {
            this.commit('removeToken');
            router.push("/login");
          }
        });
    },
    updateUsuario(state, usuario) {
      Vue.axios.put(this.state.endpoints.baseUrl + "usuario/" + usuario.id + "/", usuario)
        .then(response => {
          return response;
        })
        .catch(error => {
          if (error.request.status === 401) {
            this.commit('removeToken');
            router.push("/login");
          }
        });
    },
    createUsuario(state, usuario) {
      Vue.axios.post(this.state.endpoints.baseUrl + "usuario/", usuario)
        .then(response => {
          return response;
        })
        .catch(error => {
          if (error.request.status === 401) {
            this.commit('removeToken');
            router.push("/login");
          }
        });
    },
    deleteUsuario(state, usuario) {
      usuario.is_active = false;
      Vue.axios.delete(this.state.endpoints.baseUrl + "usuario/" + usuario.id + "/", usuario)
        .then(response => {
          return response;
        })
        .catch(error => {
          if (error.request.status === 401) {
            this.commit('removeToken');
            router.push("/login");
          }
        });
    },


    // FIN METODOS DE USUARIOS  ----------------------------------------------->

    //METODOS BITACORA ---------------------------------------------------->

    getBitacora() {
      Vue.axios.get(this.state.endpoints.baseUrl + "bitacora/")
        .then(response => {
          let results = response.data.results;
          let total = response.data.count;
          let next = response.data.next;
          let previous = response.data.previous;
          this.commit('updateBitacoraList', results);
          this.commit('setPaginationBitacora', { total, next, previous });
        })
        .catch(error => {
          if (error.request.status === 401) {
            this.commit('removeToken');
            router.push("/login");
          }
        });
    },
    searchBitacora(state, query) {
      Vue.axios.get(this.state.endpoints.baseUrl + "bitacora/", {
        params: {
          search: query
        }
      })
        .then(response => {
          let results = response.data.results;
          this.commit('updateBitacoraList', results);
        })
        .catch(error => {
          if (error.request.status === 401) {
            this.commit('removeToken');
            router.push("/login");
          }
        });
    },



    // FIN METODOS DE BITACORA  ----------------------------------------------->

    // METODOS LIBRO ---------------------------------------------------->

    getLibros() {
      Vue.axios.get(this.state.endpoints.baseUrl + "libro/")
        .then(response => {
          let results = response.data.results;
          let total = response.data.count;
          let next = response.data.next;
          let previous = response.data.previous;
          this.commit('updateLibroList', results);
          this.commit('setPaginationLibro', { total, next, previous });
        })
        .catch(error => {
          if (error.request.status === 401) {
            this.commit('removeToken');
            router.push("/login");
          }
        });
    },
    deleteLibro(state, libro) {
      libro.activo = false;
      Vue.axios.delete(this.state.endpoints.baseUrl + "libro/" + libro.id + "/", libro)
        .then(response => {
          return response;
        })
        .catch(error => {
          if (error.request.status === 401) {
            this.commit('removeToken');
            router.push("/login");
          }
        });
    },
    searchLibro(state, query) {
      Vue.axios.get(this.state.endpoints.baseUrl + "libro/", {
        params: {
          search: query
        }
      })
        .then(response => {
          let results = response.data.results;
          this.commit('updateLibroList', results);
        })
        .catch(error => {
          if (error.request.status === 401) {
            this.commit('removeToken');
            router.push("/login");
          }
        });
    },
    // METODOS PRESTAMO ---------------------------------------------------->
    getAlumno() {
      Vue.axios.get(this.state.endpoints.baseUrl + "libro/")
        .then(response => {
          let results = response.data.results;
          let total = response.data.count;
          let next = response.data.next;
          let previous = response.data.previous;
          this.commit('updateLibroList', results);
          this.commit('setPaginationLibro', { total, next, previous });
        })
        .catch(error => {
          if (error.request.status === 401) {
            this.commit('removeToken');
            router.push("/login");
          }
        });
    },
  }
});
